module.exports = {
  calls: 'звонков',
};
